/**
 * React Query hook for Testers API
 */

import { useQuery } from '@tanstack/react-query';
import { testersApi } from '../services/testers';

export const testersKeys = {
  all: ['testers'] as const,
  list: () => [...testersKeys.all, 'list'] as const,
};

/**
 * Hook to fetch list of testers from Cognito.
 * Only fetches when enabled (lazy-load when popover opens).
 */
export function useTesters(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: testersKeys.list(),
    queryFn: () => testersApi.list(),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
  });
}
